import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ClientFilterForm from "../components/client/ClientFilterForm";
import { ClientFilter } from "./types/ClientFilterTypes";
import {defaultFilter, parseFilter} from "./utils/filterUtils";
import { FilterDrawer } from "../components/common/FilterDrawer";

interface ClientFilterContextType {
  filter: ClientFilter;
  handleFilterChange: (filter: ClientFilter) => void;
}

const ClientFilterContext = createContext<ClientFilterContextType>({
  filter: defaultFilter,
  handleFilterChange: () => {},
});

export const useClientFilter = () => useContext(ClientFilterContext);


export const ClientFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const [clientFilter, setClientFilter] = useState<ClientFilter>(() => {
    return parseFilter(location.search);
  });

  const handleFilterChange = useCallback((newFilter: ClientFilter) => {
    setClientFilter(newFilter);
  }, []);

  const handleDrawerToggle = useCallback(() => {
    setOpen(!open);
  }, [open]);

  useEffect(() => {
    const newFilter = parseFilter(location.search);
    setClientFilter(newFilter);
  }, [location.search]);

  const filterContent = (
    <ClientFilterForm filter={clientFilter} />
  );

  return (
    <ClientFilterContext.Provider value={{ filter: clientFilter, handleFilterChange }}>
      <FilterDrawer
        open={open}
        onToggle={handleDrawerToggle}
        filterContent={filterContent}
      >
        {children}
      </FilterDrawer>
    </ClientFilterContext.Provider>
  );
};
